import React from 'react'
import style from "./singleProduct.module.css";
import Header from '../components/header/Header';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';

const SignleProduect = () => {
  return (
    <>
    <Header/>
    <Navbar/>
    <h1>Single Product</h1>
    <Footer/>
    </>
    )
}

export default SignleProduect
